export function signedSummary(signed: number, total: number): string {
  return `${signed} of ${total} signed`;
}
